import React from "react";
import {
  FormGroup,
  FormControl,
  Row,
  Col,
  InputGroup,
  Glyphicon,
} from "react-bootstrap";

const SearchBar = ({ value, onChange, onSearch, onClear, placeholder }) => {
  return (
    <FormGroup>
      <Row>
        <Col xs={12}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <InputGroup style={{ maxWidth: "500px", width: "100%" }}>
              <FormControl
                type="text"
                value={value}
                placeholder={placeholder}
                onChange={onChange}
              />
              <InputGroup.Addon
                onClick={value ? onClear : onSearch}
                style={{ cursor: "pointer" }}
              >
                <Glyphicon glyph={value ? "remove" : "search"} />
              </InputGroup.Addon>
            </InputGroup>
          </div>
        </Col>
      </Row>
    </FormGroup>
  );
};

export default SearchBar;
